module.exports = __webpack_public_path__ + "static/how-flexible-space-can-help-the-global-skills-emergency-f8540fcf888ac2cc014d475d4f362ae7.png";